import { GameLogic, SlotConstantsBehavior, SlotEventConstantsBehavior, winMeterBg } from "@quest/murka-games-behavior-panther/dist";
import { SlotConstants, SlotEventConstants } from "@quest/slot-core";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { BaseCoreConstants, delayedCall, dispatcher, EventConstants, IEvent, ingenuity, killDelayedCall, Loading } from "@quest/base-core";
import { GameParserModel } from "../Platform/GameParserModel";
import { EventConstants as platformEventConstants } from "@quest/platform-core/dist/Base/EventConstants";
import { EventConstantsLeander } from "@quest/oddsworks-platform";

export class GameClientLogic extends GameLogic {

     /**
     * onShowNextWinPresentation, it execute win presentation one by one in sequence defind in model
     * @param evt
     */
     onShowNextWinPresentation(evt:any) {
        const winSequenceCounter = this.model.getAnimationSequenceCounter(); // animation sequence counter , which increase its value agter every win sequence execution
        if (winSequenceCounter >= this.model.getAnimationSequence().length) {
            return;
        }
        const sequenceArray = this.model.getAnimationSequence(); // animation sequence array
        const currentWinEventToShow = sequenceArray[winSequenceCounter]; // current win presentation to show from win sequence
        this.updateAnimationSequenceCounter(); // update sequnce number after every current sequence pick and to execute next sequence
        switch (currentWinEventToShow) {
            case "stackSymbol":
                this.onShowStackSymbol();
                break;
            case "showAllFrames":
                this.onShowAllFrames();
                break;
            case "fgBigWin":
                this.onShowFgBigWin();
                break;
                case "holdAndReSpinTriggeringAnimation":
                    this.onHoldAndReSpinTriggeringAnimation();
                    break;
                  case "holdAndReSpin":
                    this.onShowHoldAndRespin();
                    break;
            case "bigWin":
                this.onShowBigWin();
                break;
            case "firstToggle":
                this.onFirstToggle();
                break;
            case "triggeringAnimation":
                this.onTriggeringAnimation();
                break;
            case "retriggeringAnimation":
                this.onRetriggeringAnimation();
                break;
            case "freeSpin":
                if (!winMeterBg.getIsTickUpRunning()) {
                    this.onFreeSpinPresentation();
                }
                else {
                    winMeterBg.setTickupCallBack(this.onFreeSpinPresentation);
                }
                break;
            case "doNextSpinInFreeGame":
                this.doNextSpinInFreeGame();
                break;
            case "sendCloseRequest":
                this.sendCloseRequest();
                break;
        }
    }

      /**
   * to make this unction Bspot specific
   */
  protected handleGameAfterErrorResolved(): void {
    if(ingenuity.configData.isBSPOTEnable){
      super.handleGameAfterErrorResolved();
    }
  }

     /**
     * Show stage click player msg in case of hold and respin feature + Line win
     */
    onFirstToggle() {
        ingenuity.configData.playAllSymbolAnim = false;
        if (this.model.getIsAutoPlayLeft()) {
            dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_ALL_SYMBOL_ANIM);
            dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
        }
        else {
            if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
                if (((ingenuity.parserModel as GameParserModel).getHoldAndRespinStatus()) && this.model.getIsLineWins() && this.model.getWinLinesData().length > 0) {
                    dispatcher.fireEvent(SlotEventConstantsBehavior.BEGIN_STAGE_CLICK);
                    ingenuity.configData.enableStageClickOnFirstToggle = true;
                }
            }
            super.onFirstToggle();
        }
    }

    /**
     * 
     */

    protected onShowFgBigWin(): void {
      if (this.model.getIsFgBigWin() && ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
        this.startTheBigWinPresentation();
        //dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_ALL_SYMBOL_ANIM);
        dispatcher.fireEvent(SlotEventConstantsBehavior.BEGIN_STAGE_CLICK);
        dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_FG_BUTTON_PANEL_ON_TOP);
    }
    else {
        dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    }
    }
    /**
   * This method will run the bonus symbols triggering and animation play logic
   */
  private onHoldAndReSpinTriggeringAnimation(): void {
    if (
      (ingenuity.parserModel as GameParserModel).getHoldAndRespinStatus() &&
      ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState
    ) {
      if (Loading.isStateLoaded(BaseCoreConstants.loader.STAGE_FREE_GAME)) {
        dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_POST_LOADER);
        ingenuity.configData.enableStageClickOnFirstToggle = false;
        dispatcher.fireEvent(SlotEventConstantsBehavior.DISABLE_STAGE_CLICK);
        //dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_STAGE_CLICK_PLAYER_MSG);
        dispatcher.fireEvent(eventDispatchers.ON_START_BONUS_PRESENTATION);
      } else {
        dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_POST_LOADER);
        dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
        dispatcher.on(
          EventConstants.FREEGAME_ASSETS_LOADED,
          (e: IEvent) => {
            this.onHoldAndReSpinTriggeringAnimation();
          },
          this,
          true
        );
      }
    } else {
      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    }
  }
  private onShowHoldAndRespin(): void {
    if (
      (ingenuity.parserModel as GameParserModel).getHoldAndRespinStatus() &&
      ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState
    ) {
      //dispatcher.fireEvent(SlotEventConstants.HIDE_BASEGAME_VIEW)
      dispatcher.fireEvent(eventDispatchers.INITIALIZE_HOLD_AND_RESPIN);
      dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_BUTTON_PANEL_ON_TOP);

      dispatcher.fireEvent(eventDispatchers.SHOW_BONUS_REEL);
      dispatcher.fireEvent(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION);
      dispatcher.fireEvent(SlotEventConstants.STOP_ALL_WIN_ANIMATIONS);
    } else {
      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    }
  }

  protected onCheckForWinAfterReelStop(evt: IEvent): void {
    if ((ingenuity.parserModel as GameParserModel).getIsFreeSpintriggered() || (ingenuity.parserModel as GameParserModel).getIsFreeSpinRetriggered()) {
      dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
  }
  if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      dispatcher.fireEvent(SlotEventConstants.FG_SHOW_SPIN_BTN_HIDE_STOP_BTN);
  }
   else {
      dispatcher.fireEvent(SlotEventConstants.SHOW_SPIN_BTN_HIDE_STOP_BTN);
  }
  if (this.model.getIsWin() && (ingenuity.parserModel as GameParserModel).getTotalWin() || (ingenuity.parserModel as GameParserModel).getIsFreeSpinRetriggered() || (ingenuity.parserModel as GameParserModel).getHoldAndRespinStatus() || (ingenuity.parserModel as GameParserModel).getHasFreeGamesWin()) {
      this.setWinlineAndWaysData();
      killDelayedCall(SlotConstantsBehavior.BROKEN_DELAY_FG);
      this.showNextWinPresentation();
  }
  else {
      delayedCall(SlotConstantsBehavior.NoWinDelay, SlotConstantsBehavior.setDelayForNoWin, () => {
          killDelayedCall(SlotConstantsBehavior.NoWinDelay);
          dispatcher.fireEvent(SlotEventConstants.SHOW_CONTAINERS, SlotConstantsBehavior.ButtonsContainerId);
      });
  }
  (ingenuity.parserModel as GameParserModel).setisSpinStarted(false);
  }

  protected sendCloseRequest(): void {
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState && !ingenuity.configData.endReqSent) {
      if (!(ingenuity.parserModel as GameParserModel).getHasFreeGamesWin()&&
      !(ingenuity.parserModel as GameParserModel).getHoldAndRespinStatus()) {
          if ((ingenuity.parserModel as GameParserModel).getNoSettleOnError()) {
              (ingenuity.parserModel as GameParserModel).setNoSettleOnError(false);
              dispatcher.fireEvent(SlotEventConstants.ENABLED_ALL_BUTTONS);
          }
          else {
              dispatcher.fireEvent(platformEventConstants.GAME_CLOSE);
              dispatcher.fireEvent(EventConstantsLeander.TOTAL_WIN_UPDATED, { winAmount: (ingenuity.parserModel as GameParserModel).getCurrentSpinTotalWinAmt().toFixed(2) });
          }
          ingenuity.configData.endReqSent = true;
      }
  }
  else if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      dispatcher.fireEvent(SlotEventConstants.DO_NEXT_SPIN);
  }
  }

}
